import clsx from "clsx";
import React, { type FC } from "react";

interface TypographyProps {
  children?: React.ReactNode;
  className?: string;
}

const H1: FC<TypographyProps> = ({ children, className }) => {
  return (
    <p className={clsx("app-text-h1 print:text-[32px]", className)}>
      {children}
    </p>
  );
};

const H2: FC<TypographyProps> = ({ children, className }) => {
  return (
    <p className={clsx("app-text-h2 print:text-[28px]", className)}>
      {children}
    </p>
  );
};

const H3: FC<TypographyProps> = ({ children, className }) => {
  return (
    <p className={clsx("app-text-h3 print:text-[24px]", className)}>
      {children}
    </p>
  );
};

const H4: FC<TypographyProps> = ({ children, className }) => {
  return (
    <p className={clsx("app-text-h4 print:text-[20px]", className)}>
      {children}
    </p>
  );
};

const H5: FC<TypographyProps> = ({ children, className }) => {
  return (
    <p className={clsx("app-text-h5 print:text-[18px]", className)}>
      {children}
    </p>
  );
};

const H6: FC<TypographyProps> = ({ children, className }) => {
  return (
    <p className={clsx("app-text-h6 print:text-[16px]", className)}>
      {children}
    </p>
  );
};

const Body1: FC<TypographyProps> = ({ children, className }) => {
  return (
    <p className={clsx("app-text-body1 print:text-[16px]", className)}>
      {children}
    </p>
  );
};

const Body1R: FC<TypographyProps> = ({ children, className }) => {
  return (
    <p className={clsx("app-text-body1-medium print:text-[16px]", className)}>
      {children}
    </p>
  );
};

const Body1B: FC<TypographyProps> = ({ children, className }) => {
  return (
    <p className={clsx("app-text-body1-bold print:text-[16px]", className)}>
      {children}
    </p>
  );
};

const Body2: FC<TypographyProps> = ({ children, className }) => {
  return (
    <p className={clsx("app-text-body2 print:text-[14px]", className)}>
      {children}
    </p>
  );
};

const Body2R: FC<TypographyProps> = ({ children, className }) => {
  return (
    <p className={clsx("app-text-body2-medium print:text-[14px]", className)}>
      {children}
    </p>
  );
};

const Body2B: FC<TypographyProps> = ({ children, className }) => {
  return (
    <p className={clsx("app-text-body2-bold print:text-[14px]", className)}>
      {children}
    </p>
  );
};

const Sub1: FC<TypographyProps> = ({ children, className }) => {
  return (
    <p className={clsx("app-text-sub1 print:text-[12px]", className)}>
      {children}
    </p>
  );
};

const Sub2: FC<TypographyProps> = ({ children, className }) => {
  return (
    <p className={clsx("app-text-sub2 print:text-[12px]", className)}>
      {children}
    </p>
  );
};

const Sub3: FC<TypographyProps> = ({ children, className }) => {
  return (
    <p className={clsx("app-text-sub3 print:text-[12px]", className)}>
      {children}
    </p>
  );
};

const Sub4: FC<TypographyProps> = ({ children, className }) => {
  return (
    <p className={clsx("app-text-sub4 print:text-[8px]", className)}>
      {children}
    </p>
  );
};

const ButtonText: FC<TypographyProps> = ({ children, className }) => {
  return (
    <p className={clsx("app-text-button-text print:text-[14px]", className)}>
      {children}
    </p>
  );
};

const LinkText: FC<TypographyProps> = ({ children, className }) => {
  return (
    <p className={clsx("app-text-link print:text-[14px]", className)}>
      {children}
    </p>
  );
};

const SmallText: FC<TypographyProps> = ({ children, className }) => {
  return (
    <p className={clsx("app-text-small print:text-[10px]", className)}>
      {children}
    </p>
  );
};

export {
  H1,
  H2,
  H3,
  H4,
  H5,
  H6,
  Body1,
  Body1R,
  Body1B,
  Body2,
  Body2B,
  Body2R,
  Sub1,
  Sub2,
  Sub3,
  Sub4,
  ButtonText,
  LinkText,
  SmallText,
};
